import Api from '../../../common/services/api';

export const ADMIN_REMOVE_TEAM = 'admin/REMOVE_TEAM';

export default (teamId) => async (dispatch, getState) => {
  const { network: { selected, teams } } = getState();

  const team = teams.items[teamId];

  await Api.delete(`/v2/networks/${selected}/teams/${teamId}`);

  dispatch({
    type: ADMIN_REMOVE_TEAM,
    teamId,
    functionId: team ? team.function_id : null,
  });
};
